import {
  VITE_APP_BASE_URL,
  VITE_APP_CAYMAN_BASE_URL,
} from '@/constants/configs';
import { ROUTE } from '@/constants/routes';

import { CountryISO } from '@/types/places';

const CAYMAN_DOMAIN = 'caymannational';

export const isCaymanDomain =
  typeof window !== 'undefined' &&
  window.location.hostname.includes(CAYMAN_DOMAIN);

export function navigateToAppDomain(countryCode: string) {
  const isCaymanSelected = countryCode && countryCode === CountryISO.Cayman;
  if (isCaymanDomain) {
    if (!isCaymanSelected && VITE_APP_BASE_URL) {
      window.location.href = `${VITE_APP_BASE_URL}${ROUTE.ONBOARDING}/${countryCode.toLowerCase()}`;
      return true;
    }
  } else if (isCaymanSelected && VITE_APP_CAYMAN_BASE_URL) {
    window.location.href = VITE_APP_CAYMAN_BASE_URL;
    return true;
  }

  return false;
}

export const getRelativeUrl = () => {
  const url = new URL(window.location.href);
  return {
    pathname: url.pathname,
    search: url.search,
    hash: url.hash,
  };
};
